import React, { useState } from "react";
import Layout from "../../Layout";
import { AiOutlineInfoCircle } from "react-icons/ai";
import { Button, Input } from "../../components/Form";
import { FaSave } from "react-icons/fa";
import { useNavigate } from "react-router";

import { joinLab } from "../../api/labEmployee";

function Invitation() {
	const navigate = useNavigate();

	const [invitationCode, setInvitationCode] = useState("");
	const [loading, setLoading] = useState(false);

	const handleSubmit = async (e) => {
		e.preventDefault();

		setLoading(true);
		const res = await joinLab({ invitationCode: invitationCode });
		if (res) {
			setLoading(false);
			setInvitationCode("");
			navigate("/");
		}
		setLoading(false);
		setInvitationCode("");
	}

	return (
		<Layout>
			<div className="flex justify-center">
				<div className="flex flex-col max-w-[21rem] items-center">
					<img
						src="https://app.dentallabguru.com/assets/img/logo-dark.png"
						className="w-32"
						alt=""
					/>
					<div className="flex justify-center items-center text-gray-500 text-sm text-center my-5">
						<span className="self-start">
							<AiOutlineInfoCircle size={18} className="inline-block text-subMain" />
						</span>
						Please enter invitation code generated by lab owner
					</div>
					<Input label={"Invitation Code"} placeholder={"Invitation Code"} color value={invitationCode} onChange={(e) => setInvitationCode(e.target.value)} />
					<Button className={"my-4 mx-2"} label={"Accept"} Icon={FaSave} onClick={handleSubmit} loading={loading} />
					<Button className={"w-full bg-transparent !text-subMain"} label={"I WANT TO CREATE MY LAB"} onClick={() => navigate("/new-lab")} />
				</div>
			</div>
		</Layout>
	);
}

export default Invitation;
